var heading_default = {
  "fontElementMap": "z4o01",
  "elementSpacing": "f8Gtu",
  "headerOne": "wvKUy f8Gtu",
  "headerTwo": "PNVVR f8Gtu",
  "headerThree": "_59wbK f8Gtu",
  "headerFour": "i8ahc f8Gtu",
  "headerFive": "zLmUg f8Gtu",
  "headerSix": "cPMih f8Gtu",
  "child": "BfUCQ"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
